import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { Button, Panel, theme, Text, Link } from '@xometry/xometry_loft';
import { resetPasswordStyles } from './ULPResetPassword.styled';
import { EmailSentIcon } from './EmailSentIcon';
import { WWW_ORIGIN } from '../../../config';

export const ULPResetPassword = () => {
  window.analytics.page('Reset Password');

  const location = useLocation();
  const navigate = useNavigate();

  const email_address = queryString.parse(location.search).email_address || '';

  const handleResendEmail = () => {
    if (document.referrer.includes('ulp-forgot-password')) {
      window.history.back();
    } else {
      navigate(
        `/account/ulp-forgot-password?email_address=${encodeURIComponent(
          email_address as string
        )}`
      );
    }
  };

  return (
    <Panel kind="secondary" css={resetPasswordStyles.panel}>
      <div>
        <EmailSentIcon />
      </div>
      <Text kind="panel-title" fontWeight={600} margin="32px 0 12px">
        Check Your Email
      </Text>
      <Text kind="body-sm" width="100%" textAlign="center" marginBottom="12px">
        Please check the email address <b>{email_address}</b> for instructions
        to reset your password. If you don&apos;t receive an email shortly
        please contact us at&nbsp;
        <a href="mailto:support@xometry.com">support@xometry.com</a>.
      </Text>
      <Button
        kind={theme.kind.primaryOutline}
        css={resetPasswordStyles.button}
        scale="xlarge"
        onClick={handleResendEmail}
      >
        Resend Email
      </Button>
      <Text
        kind="body-sm"
        color={theme.colors.darkBlues[75]}
        marginTop={theme.space[2]}
      >
        Don&apos;t have an account?
        <Link
          kind="text-blue"
          marginLeft="6px"
          href={`${WWW_ORIGIN}/signup?email=${email_address}`}
        >
          Sign up
        </Link>
      </Text>
    </Panel>
  );
};
